function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.86623 13.1704H1.50443C0.679421 13.1704 0 13.8778 0 14.7367V15.7472C0 15.882 0.113237 15.9999 0.24265 15.9999H5.11183C5.24125 15.9999 5.35448 15.882 5.35448 15.7472V14.7367C5.37066 13.8778 4.69124 13.1704 3.86623 13.1704Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.6851 12.6482C3.51597 12.6482 4.18953 11.947 4.18953 11.0819C4.18953 10.2169 3.51597 9.51562 2.6851 9.51562C1.85422 9.51562 1.18066 10.2169 1.18066 11.0819C1.18066 11.947 1.85422 12.6482 2.6851 12.6482Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4014 11.8904H8.03959C7.21458 11.8904 6.53516 12.5977 6.53516 13.4567V14.4504C6.53516 14.5851 6.64839 14.703 6.77781 14.703H11.647C11.7764 14.703 11.8896 14.5851 11.8896 14.4504V13.4567C11.9058 12.5809 11.2264 11.8904 10.4014 11.8904Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.22074 11.3682C10.0516 11.3682 10.7252 10.667 10.7252 9.80191C10.7252 8.93686 10.0516 8.2356 9.22074 8.2356C8.38986 8.2356 7.71631 8.93686 7.71631 9.80191C7.71631 10.667 8.38986 11.3682 9.22074 11.3682Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.92958 3.57052V5.17051H9.52811C9.62517 5.17051 9.72223 5.2042 9.80312 5.27156L11.3884 6.60209C11.5987 6.78735 11.9061 6.61893 11.9061 6.34946V1.04421C11.9061 0.471578 11.4531 0 10.9031 0H4.85305C4.30304 0 3.8501 0.471578 3.8501 1.04421V1.61684H7.06926C8.08839 1.61684 8.92958 2.49262 8.92958 3.57052Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0.517654 9.12845L2.10297 7.79793C2.18385 7.73056 2.28091 7.69687 2.37797 7.69687H7.06921C7.61922 7.69687 8.07217 7.2253 8.07217 6.65267V3.57057C8.07217 2.99794 7.61922 2.52637 7.06921 2.52637H1.00295C0.452947 2.52637 0 2.99794 0 3.57057V8.87582C0 9.14529 0.307357 9.29687 0.517654 9.12845ZM6.14714 4.4632C6.48685 4.4632 6.76186 4.74952 6.76186 5.1032C6.76186 5.45688 6.48685 5.7432 6.14714 5.7432C5.80743 5.7432 5.53243 5.45688 5.53243 5.1032C5.53243 4.74952 5.80743 4.4632 6.14714 4.4632ZM4.028 4.4632C4.36771 4.4632 4.64271 4.74952 4.64271 5.1032C4.64271 5.45688 4.36771 5.7432 4.028 5.7432C3.68828 5.7432 3.41328 5.45688 3.41328 5.1032C3.41328 4.74952 3.68828 4.4632 4.028 4.4632ZM1.92503 4.4632C2.26474 4.4632 2.53974 4.74952 2.53974 5.1032C2.53974 5.45688 2.26474 5.7432 1.92503 5.7432C1.58532 5.7432 1.31031 5.45688 1.31031 5.1032C1.29414 4.74952 1.56914 4.4632 1.92503 4.4632Z",
  fill: "currentColor"
});

function SvgCommunication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.e5f63676.svg";
export { ForwardRef as ReactComponent };